const shared_stylesheets = require.context('shared/stylesheets/', true, /\.css$/)
const application_stylesheets = require.context('application/stylesheets/', true, /\.css$/)

shared_stylesheets.keys().forEach(shared_stylesheets)
application_stylesheets.keys().forEach(application_stylesheets)